window.dd = console.log;
window.php  = {};

window.php.empty = require('locutus/php/var/empty');
window.php.is_numeric = require('locutus/php/var/is_numeric');

window.php.ceil = require('locutus/php/math/ceil');
window.php.floor = require('locutus/php/math/floor');
window.php.abs = require('locutus/php/math/abs');
window.php.fmod = require('locutus/php/math/fmod');

window.php.urlencode = require('locutus/php/url/urlencode');
window.php.http_build_query = require('locutus/php/url/http_build_query');

window.php.strtotime = require('locutus/php/datetime/strtotime');
window.php.date = require('locutus/php/datetime/date');

window.php.substr_count = require('locutus/php/strings/substr_count');
window.php.nl2br = require('locutus/php/strings/nl2br');
window.php.htmlspecialchars = require('locutus/php/strings/htmlspecialchars');
window.php.number_format = require('locutus/php/strings/number_format');
window.php.sprintf = require('locutus/php/strings/sprintf');
window.php.str_pad = require('locutus/php/strings/str_pad');
window.php.substr_replace = require('locutus/php/strings/substr_replace');
window.php.trim = require('locutus/php/strings/trim');
window.php.rtrim = require('locutus/php/strings/rtrim');
window.php.ltrim = require('locutus/php/strings/ltrim');
window.php.parse_str = require('locutus/php/strings/parse_str');
window.php.strip_tags = require('locutus/php/strings/strip_tags');
window.php.html_entity_decode = require('locutus/php/strings/html_entity_decode');
window.php.htmlentities = require('locutus/php/strings/htmlentities');
window.php.number_format = require('locutus/php/strings/number_format');

window.php.preg_quote = require('locutus/php/pcre/preg_quote');

window.php.array_shift = require('locutus/php/array/array_shift');
window.php.array_pop = require('locutus/php/array/array_pop');
window.php.array_merge = require('locutus/php/array/array_merge');
window.php.array_keys = require('locutus/php/array/array_keys');
window.php.array_values = require('locutus/php/array/array_values');
window.php.array_unique = require('locutus/php/array/array_unique');
window.php.array_fill = require('locutus/php/array/array_fill');
window.php.in_array = require('locutus/php/array/in_array');

window.php.json_encode = require('locutus/php/json/json_encode');

window.php.pathinfo = require('locutus/php/filesystem/pathinfo');